import * as React from 'react';
import { useState, useEffect } from 'react';
import { useDataProvider, Loading, Error } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    sb:{
        border: 'none',
        cursor: 'default',
        height: '32px',
        margin: '2px',
        display: 'inline-flex',
        outline: '0',
        padding: '0',
        fontSize: '0.8125rem',
        boxSizing: 'border_box',
        alignItems: 'center',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        whiteSpace: 'nowrap',
        borderRadius: '16px',
        verticalAlign: 'middle',
        justifyContent: 'center',
        textDecoration: 'none',
        paddingLeft: '12px',
        paddingRight: '12px',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
}));

export default function Subcategory ({record}) {
    const dataProvider = useDataProvider();
    const classes = useStyles();
    const [subcategory, setSubcategory] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const subIds = [];
    const { categories } = record;
    const sub = categories.map(subit => {
        const {subcategories} = subit;
         subcategories.map(itm => {
             subIds.push(itm);
         })
    });

    useEffect(() => {
        dataProvider.getMany('categories', {ids: subIds })
            .then(({ data }) => {
                setSubcategory(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })
    }, [dataProvider, subIds]);

    if (loading) return <Loading />;
    if (error) return <Error />;
    return(
        <div>
        {subcategory.map(item => (
                <span className={classes.sb} key={item.id}>{item.name}</span>
            ))}
        </div>
    );
}